// extracted by mini-css-extract-plugin
module.exports = {"row":"PortalsTable_row__2XYE8"};